var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCropSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M344 400H112V8C112 3.594 108.406 0 104 0S96 3.594 96 8V96H8C3.594 96 0 99.594 0 104S3.594 112 8 112H96V408C96 412.406 99.594 416 104 416H344C348.406 416 352 412.406 352 408S348.406 400 344 400ZM504 400H416V104C416 99.582 412.418 96 408 96H168C163.594 96 160 99.594 160 104S163.594 112 168 112H400V504C400 508.406 403.594 512 408 512S416 508.406 416 504V416H504C508.406 416 512 412.406 512 408S508.406 400 504 400Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropSimple);
export default __webpack_public_path__ + "static/media/crop-simple.d4bad99b504293e0d5e0987ad0540400.svg";
export { ForwardRef as ReactComponent };